(function(angular) {
    angular.module('bizPartEngage').service('core.level.serivce', levelService);

    levelService.$inject = ["$http"];

    function levelService($http) {
        this.GetLoggedInUserExperiencePointHistory = function(max, page) {
            return $http.get(siteRootPath + 'api/level/GetLoggedInUserExperiencePointHistory?' + $.param({max: max, page:page}));
        };

        this.GetExperienceValueFromLastCheck = function() {
            return $http.get(siteRootPath + 'api/level/GetExperienceValueFromLastCheck');
        };

        this.CheckForLevelUp = function() {
            return $http.get(siteRootPath + 'api/level/CheckForLevelUp');
        };
    }
})(window.angular);
